/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var config = require('../../config/Config');
var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(id) {
  var deferred = $.Deferred();

  $.soap({
    url: config.getAnonymousDoBSUrl(),
    body: {
      GetComplaint: {
        $xmlns: 'http://dobs.pa.gov/complaint/db/1.0',
        id: id
      }
    },
    blueprint: {
      fname: '$..fname',
      lname: '$..lname',
      title: '$..title',
      phonenumber: '$..phonenumber',
      email: '$..email',
      reasonforcontact: '$..reasonforcontact',
      street: '$..street',
      city: '$..city',
      state: '$..state',
      zip: '$..zipcode',
      institutionName: '$..InstitutionName',
      accountnumber: '$..accountnumber',
      institutionAddress: '$..institutionstreet',
      institutionCityStateZip: '$..institutioncitystatezip'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};

